import { createTRPCClient, httpLink, splitLink } from "@trpc/client";
import type { PortalRouter } from "../../../../server/src/index";
import superjson from "superjson";
import Cookies from "js-cookie";
import { API_URL } from "../constants/api.const";
import { COOKIE_KEYS } from "@/shared/constants/cookies.const";

// Get token from cookies
export const getToken = () => {
  return Cookies.get(COOKIE_KEYS.token);
};

// Save token to cookies
export const saveToken = (token: string) => {
  Cookies.set(COOKIE_KEYS.token, token, {
    path: "/",
    sameSite: "lax",
    secure: false, // true in production with HTTPS
  });
};

// Remove token (logout)
export const removeToken = () => {
  Cookies.remove(COOKIE_KEYS.token, { path: "/" });
};

// Check if logged in
export const isLoggedIn = () => {
  return !!getToken();
};

// tRPC client
const trpc = createTRPCClient<PortalRouter>({
  links: [
    splitLink({
      condition: () => !!getToken(),
      true: httpLink({
        url: `${API_URL}/trpc`,
        headers: () => ({
          Authorization: `Bearer ${getToken()}`,
        }),
        transformer: superjson,
      }),
      false: httpLink({
        url: `${API_URL}/trpc`,
        transformer: superjson,
      }),
    }),
  ],
});

export default trpc;
